import * as moment from "moment";
import { ImmunisationListModel } from "@teamprevent/common/immunisation/models";

import * as actions from "./actiontypes";
import { ImmunisationHistoryAction } from "./actions";

export function immunisations(state: ImmunisationListModel[] = [], action: ImmunisationHistoryAction): ImmunisationListModel[] {
    switch (action.type) {
        case actions.LOAD_IMMUNISATIONS_SUCCESS:
            return action.payload.map(c => ({ ...c, listUpdated: moment() }));
        default:
            return state;
    }
}
